import FieldBase from './FieldBase'

export default class extends FieldBase {
  constructor({ errors, ...args }) {
    super(args)
    this.attrs.error = ''
    this.children = [
      {
        ...this.getComponentWithVModel('link-input'),
        props: {
          errors: errors || this.getErrorsForPath(this.modelPath)
        }
      }
    ]
  }
}
